import './set-public-path.js'
import React from 'react';
import ReactDOM from 'react-dom';
import singleSpaReact from 'single-spa-react';
import singleSpaCanopy from 'single-spa-canopy';
import { property } from 'lodash';
import * as VirusHelper from 'src/virus-dialog/virus.helpers'

function getLinkedFileList() {
  return import(/* webpackChunkName: "linked-file-list" */ 'src/global-files/inbox/cards/linked-file-list.component.js');
}

function getPreviewer() {
  return import(/* webpackChunkName: "preview" */ 'src/documents/preview/preview.component.js');
}

export { SimpleDocumentPreviewParcel } from 'src/documents/simple-preview/simple-document-preview.component';
export { SaveToCanopyFilesDropdownParcel } from 'src/documents/save-to-canopy-files-dropdown/save-to-canopy-files-dropdown.parcel';
export { VirusModalParcel } from 'src/virus-dialog/virus-modal.parcel'
export { uploadFiles } from 'src/global-files/resources/files.resource.js'
export const LinkedFileListLazy = React.lazy(() => fetchToggles().then(getLinkedFileList));
export const isFileSafeToOpen = (fileId, purpose) => VirusHelper.isFileSafeToOpen(fileId, purpose);
export { truncateFilename } from 'src/common/file.helpers.js'
export { InlineDocumentPreview } from 'src/documents/simple-preview/inline-document-preview.component.js';
export const Preview = React.lazy(() => fetchToggles().then(getPreviewer))

const reactLifecycles = singleSpaReact({
  React,
  ReactDOM,
  loadRootComponent: () => import(/* webpackChunkName: "root-routes" */ './root.routes.js').then(property('default')),
  domElementGetter,
});

export const toggles = ['file_versioning', 'manual_lock', 'page_manipulation', 'boots_protocol', 'toggle_team_folder_permissions', 'toggle_file_attachments'];

function fetchToggles () {
  return SystemJS.import('feature-toggles!sofe').then(fui => fui.fetchFeatureToggles(...toggles))
}

const canopyLifecycles = singleSpaCanopy({
  domElementGetter,
  childAppName: 'docs-ui',
  mainContentTransition: false,
  featureToggles: toggles,
});

export const bootstrap = [
  canopyLifecycles.bootstrap,
  reactLifecycles.bootstrap,
];

export const mount = [
  reactLifecycles.mount,
  canopyLifecycles.mount,
];

export const unmount = [
  reactLifecycles.unmount,
  canopyLifecycles.unmount,
];

function domElementGetter() {
  let docsUi = document.getElementById('docs-ui');
  if (docsUi) return docsUi;

  // If the element doesn't exist then create it
  let container = document.createElement('div');
  container.setAttribute('id', 'docs-ui');
  document.body.appendChild(container);
  return container;
}

export function loadInboxDrawer() {
  return fetchToggles().then(() => import(/* webpackChunkName: "inbox-drawer" */ 'src/global-files/inbox/inbox-drawer.component'))
    .then(module => module.inboxDrawer)
}

export function loadFilePickerModal() {
  return fetchToggles().then(() => import(/* webpackChunkName: "file-picker" */ 'src/global-files/file-picker-modal.component.js')
      .then(module => module.filePickerModal))
}

export function LinkedFileCardFn() {
  return fetchToggles().then(() => import(/* webpackChunkName: "linked-file-card" */ 'src/global-files/inbox/cards/linked-file-card.component.js'));
}

export function loadDocIcon() {
  return fetchToggles().then(() => import(/* webpackChunkName: "doc-icon" */ 'src/documents/list/document/doc-icon.component.js')
    .then(module => module))
}

export function loadFolderTemplatesModal() {
  return fetchToggles().then(() => import(/* webpackChunkName: "folder-templates-modal" */ 'src/folder-templates/folder-templates-modal.component'))
    .then(module => module.folderTemplatesModal)
}

export function loadAddFilePopupParcel() {
  return fetchToggles().then(() => import(/* webpackChunkName: "add-file-popup-parcel" */'./global-files/open-file-picker/add-file-popup.parcel.js')
    .then(module => module.AddFilePopupParcel))
}

export async function loadUploadFilesHelper() {
  await fetchToggles()
  const { uploadFilesAsync } = await import(/* webpackChunkName: "upload-files-helper" */'./global-files/resources/upload-files.helpers.js')
  return { uploadFilesAsync }
}

export function loadDropListParcel() {
  return fetchToggles().then(() => import(/* webpackChunkName: "drop-list-parcel" */'./documents/list/drop-list.wrapper.js'))
    .then(module => module.DropListParcel)
}

export function NewFileUploadParcel() {
  return fetchToggles().then(() => import(/* webpackChunkName: "upload-files-button-parcel" */'./common/new-file-upload.parcel')).then(mod => mod.NewFileUploadButtonParcel)
}
